import { create } from 'zustand';
import { NexoyaAttributionRule, NexoyaContentRule } from '../types';

export interface ContentRuleFilterState {
  contentRulesFilter: NexoyaContentRule[];
  attributionRulesFilter: NexoyaAttributionRule[];

  handleAddContentRule: (contentRule: NexoyaContentRule) => void;
  handleRemoveContentRule: (contentRule: NexoyaContentRule) => void;

  handleAddAttributionRule: (attributionRule: NexoyaAttributionRule) => void;
  handleRemoveAttributionRule: (attributionRule: NexoyaAttributionRule) => void;

  resetContentRuleFilters: (type?: 'contentRules' | 'attributionRules') => void;
}

export const useContentRuleFilterStore = create<ContentRuleFilterState>((set) => ({
  contentRulesFilter: [],
  attributionRulesFilter: [],

  handleAddContentRule: (contentRule) =>
    set((state) => ({
      contentRulesFilter: [...state.contentRulesFilter, contentRule],
    })),

  handleRemoveContentRule: (contentRule) =>
    set((state) => ({
      contentRulesFilter: state.contentRulesFilter.filter((cr) => cr.contentRuleId !== contentRule.contentRuleId),
    })),

  handleAddAttributionRule: (attributionRule) =>
    set((state) => ({
      attributionRulesFilter: [...state.attributionRulesFilter, attributionRule],
    })),

  handleRemoveAttributionRule: (attributionRule) =>
    set((state) => ({
      attributionRulesFilter: state.attributionRulesFilter.filter(
        (cr) => cr.attributionRuleId !== attributionRule.attributionRuleId,
      ),
    })),

  resetContentRuleFilters: (type) =>
    set(() => {
      if (!type) return { contentRulesFilter: [], attributionRulesFilter: [] };
      const resetMap = {
        contentRules: { contentRulesFilter: [] as NexoyaContentRule[] },
        attributionRules: { attributionRulesFilter: [] as NexoyaAttributionRule[] },
      };
      return resetMap[type] || {};
    }),
}));
